// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_DO_LOGOUT,
} from './constants';

export function doLogout() {
  return {
    type: COMMON_DO_LOGOUT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_DO_LOGOUT:
      localStorage.clear();
      return {
        ...state,
        logged:false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/doLogout.js